import { Component } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { CalendarEvent } from 'angular-calendar';
import { ReservationsServices } from "../services";
import { Observable } from 'rxjs';
import { DAYS_OF_WEEK } from 'angular-calendar';
import { ConfigurationIntegrationsPage } from '../../configuration/configuration-integrations/configuration-integrations';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ReservationConfig } from '../reservation-config/reservation-config';
import { TranslateService } from '@ngx-translate/core';
import { ReservationConfigCamps } from '../reservation-config/reservation-config-camps/reservation-config-camps';
import { CompCreateReservationPage } from '../../components/popups/create-reservation/create-reservation';
import moment from 'moment';
import { AnalyticsPage } from '../../analytics/analytics';
import { AnalyticsServices } from '../../services/analyticsServices';

@Component({
  selector: 'page-reservation-calendar',
  templateUrl: 'reservation-calendar.html',
})
export class ReservationCalendarPage {

  view: string = 'month';
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];
  activeDayIsOpen: boolean = false;
  reservations: any;
  valueChanges: any;
  preparation: any = [];
  reserva: any;
  locale: string = this.globals.restaurant.lang;
  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;

  loader = true;
  total_reservations
  total_persons
  total_median_per_day

  top_customers_sin_desplegar = [];
  top_customers_desplegado = [];
  show_top_customers = false;

  month_reservations_list = [];

  events$: Observable<Array<CalendarEvent<{ event: Event[] }>>>;

  reservation_config: any = [];
  plg_reservas_msg: boolean = false;
  form_online_total_views: any = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public http: HttpClient,
    public reservationsServices: ReservationsServices,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public analyticsServices: AnalyticsServices) {
    if (this.globals.restaurant.lang == 'en') {
      this.weekStartsOn = DAYS_OF_WEEK.SUNDAY;
    } else {
      this.weekStartsOn = DAYS_OF_WEEK.MONDAY;
    }

    if (this.navParams.get('plg_reservas_msg')) {
      this.plg_reservas_msg = this.navParams.get('plg_reservas_msg');
    }

    if (this.navParams.get('view')) {
      this.view = this.navParams.get('view');
    }

    this.events = this.reservationsServices.events; //llenamos events con los events iniciales del services. Accion solo de prueba para que no pete en los siguientes dias eliminaqr si todo ok

    this.globals.GAtrackView('Reservations', 'Reservations - View', this.globals.restaurant.email, 'View', 'View reservations', 'Reservations', '');
  }

  createReservation() {
    if (this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      var params = {
        update_state: false,
        reservation_config: this.reservation_config
      };
      if (this.view === 'day') {
        params['date'] = moment(this.reservationsServices.selected_date).format('YYYY-MM-DD');
      }
      let profileModal = this.modalCtrl.create(CompCreateReservationPage, params);
      profileModal.present();
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  async ionViewWillEnter() {

    if (this.globals.restaurant.plg_reservas_starter == true && this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.reservationsServices.book_url = 'https://book.mycheftool.com/' + this.globals.domini_sites;
      this.reservation_config = await this.reservationsServices.getReservationConfig();
      this.loader = false;
      if (this.globals.checkLimitsByLicense('reservations', 'analytics')) {
        this.getAnalyticsReservations();
      } else {
        this.loader = false;
      }
    } else if (this.globals.restaurant.plg_reservas_starter == true && !this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.loader = false;
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      this.loader = false;
    }
  }

  dayClicked(date) {
    this.viewDate = date.date;
    this.reservationsServices.selected_date = date.date;
    this.reservationsServices.getReservationsByDay();
    this.view = 'day';
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.dayClicked({ date: event.start });
  }

  openCMAInegration() {
    if (this.globals.returnRolAccess(this.globals.user_rol, 'integrations')) {
      this.globals.side_menu_config_active = 'integrations';
      this.navCtrl.push(ConfigurationIntegrationsPage, {
        option: 'covermanager'
      });
    }
  }

  openReservationsInt() {
    if (this.globals.returnRolAccess(this.globals.user_rol, 'integrations')) {
      this.globals.side_menu_config_active = 'integrations';
      this.navCtrl.push(ConfigurationIntegrationsPage);
    }
  }

  async getAnalyticsReservations() {
    this.loader = true;

    const body = new HttpParams()
      .set('public_key', this.globals.public_key);

    await this.http.post(this.globals.analytics_path + 'reservations/get_analytics_reservations', body).subscribe(async res => {


      this.total_persons = res['total_persons'];
      this.total_reservations = res['total_reservations'];
      this.total_median_per_day = this.globals.round2decimal(res['total_median_per_day']);

      this.top_customers_sin_desplegar = res['top_customers_sin_desplegar'];
      this.top_customers_desplegado = res['top_customers_desplegado'];

      this.month_reservations_list = res['month_reservations_list'];
      this.form_online_total_views = res['total_views'];

      this.loader = false;

    },
      err => {
      });
  }

  change_show_top_customers() {
    this.show_top_customers = !this.show_top_customers
  }

  changeArrow(month) {
    var arrow = document.getElementById(month.year + month.month + "_arrow");
    if (month.arrow == undefined || month.arrow) {
      arrow.classList.remove("mdi-arrow-down");
      arrow.classList.add('mdi-arrow-up');
      month.arrow = false;
    } else {
      arrow.classList.remove("mdi-arrow-up");
      arrow.classList.add('mdi-arrow-down');
      month.arrow = true;
    }
  }

  openConfig() {
    this.navCtrl.push(ReservationConfig);
  }

  configureReservations() {
    if (this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.navCtrl.push(ReservationConfigCamps);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openMonth() {
    this.globals.GAtrackView('Reservations', 'Reservations - Month - View', this.globals.restaurant.email, 'View', 'View month reservations', 'Reservations', '');
    this.view = 'month';
  }

  openDay() {
    this.globals.GAtrackView('Reservations', 'Reservations - Day - View', this.globals.restaurant.email, 'View', 'View day reservations', 'Reservations', '');
    this.view = 'day';
  }

  copyUrl() {
    this.globals.GAtrackView('Reservations', 'Reservations - Copy - Url', this.globals.restaurant.email, 'View', 'Copy book url', 'Reservations', '');
    const el = document.createElement("textarea");
    el.value = this.reservationsServices.book_url;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    const selected =
      document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    if (selected) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selected);
    }
    //tracking
    this.sendTrackingReservation();
    //toast copiado
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-copiado'),
      duration: 1000,
      position: 'top'
    });
    toast.present();
  }

  copyCode() {
    this.globals.GAtrackView('Reservations', 'Reservations - Copy - Code', this.globals.restaurant.email, 'View', 'Copy book code', 'Reservations', '');
    const el = document.createElement("textarea");
    el.value = '<iframe src="' + this.reservationsServices.book_url + '"></iframe>';
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    const selected =
      document.getSelection().rangeCount > 0
        ? document.getSelection().getRangeAt(0)
        : false;
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    if (selected) {
      document.getSelection().removeAllRanges();
      document.getSelection().addRange(selected);
    }
    //tracking
    this.sendTrackingReservation();
    //toast copiado
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-copiado'),
      duration: 1000,
      position: 'top'
    });
    toast.present();
  }

  async generateQr() {
    this.globals.GAtrackView('Reservations', 'Reservations - Generate - Qr', this.globals.restaurant.email, 'View', 'Generate book qr', 'Reservations', '');
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-generando-qr')
    });
    loadingPopup.present();
    //logo
    var logo_format;
    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }
    //tracking
    this.sendTrackingReservation();
    //http post
    this.http.post(this.globals.api_path + 'book/qr',
      {
        public_key: this.globals.public_key,
        logo: logo_format,
        lang: this.globals.restaurant.lang,
      }, {})
      .subscribe(res => {
        loadingPopup.dismiss();
        window.open(String(res['file']));
      }, error => {
        loadingPopup.dismiss();
      });
  }

  updateIonToggleStripes() {
    this.reservationsServices.getReservationsEvents(this.reservationsServices.reservations_info);
  }

  changeDate(date) {
    this.activeDayIsOpen = false;
    this.reservationsServices.selected_date = date;
    this.reservationsServices.getReservationsByDay();
  }

  async openPrint() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //Format object menu for POST send
    var reservations_send = this.reservationsServices.reservations_info_by_day.filter(x => x.state != 'denied' && x.state != 'anulated');
    var date = this.globals.returnDate(this.reservationsServices.selected_date);
    var uid = this.globals.restaurant_uid.substring(0, 3);

    this.globals.GAtrackView('Reservations', 'Reservations - Sheet - Print', this.globals.restaurant.email, 'View', 'Print Sheet', 'Reservations', this.reservationsServices.selected_date);

    this.http.post(this.globals.api_path + 'reservation/print_basic',
      {
        reservations: reservations_send,
        date: date,
        uid: uid,
        stripes: this.reservationsServices.stripes
      }, {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(String(res['file']));
        } else {
          window.open(String(res['file']), '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });
  }

  openPrintFull() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //Format object menu for POST send
    var reservations_send = this.reservationsServices.reservations_info_by_day.filter(x => x.state != 'denied' && x.state != 'anulated');
    var date = this.globals.returnDate(this.reservationsServices.selected_date);
    var uid = this.globals.restaurant_uid.substring(0, 3);

    this.globals.GAtrackView('Reservations', 'Reservations - Full - Print', this.globals.restaurant.email, 'View', 'Print Full', 'Reservations', this.reservationsServices.selected_date);

    this.http.post(this.globals.api_path + 'reservation/print_full',
      {
        reservations: reservations_send,
        date: date,
        uid: uid,
      }, {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(String(res['file']));
        } else {
          window.open(String(res['file']), '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });
  }

  openPendingList() {
    this.globals.GAtrackView('Reservations', 'Reservations - Pendings - List', this.globals.restaurant.email, 'View', 'List pendings', 'Reservations', '');
    this.view = 'pending';
    document.getElementById('calendar').scrollIntoView({
      behavior: 'smooth'
    });
  }

  desactiveReservationsOnline() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('reservas-desactivar-reservas-online'),
      message: this.translate.instant('reservas-desactivar-reservas-online-desc'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.reservation_config.form_online = false;
            this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
              form_online: this.reservation_config.form_online
            });
            this.globals.GAtrackView('Reservations', 'Reservations - OnlineForm - Deactive', this.globals.restaurant.email, 'View', 'Deactive online form', 'Reservations', '');
          }
        }
      ]
    });
    alert.present();
  }

  activeReservationsOnline() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('reservas-activar-reservas-online'),
      message: this.translate.instant('reservas-activar-reservas-online-desc'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.reservation_config.form_online = true;
            this.reservationsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
              form_online: this.reservation_config.form_online
            });
            this.globals.GAtrackView('Reservations', 'Reservations - OnlineForm - Active', this.globals.restaurant.email, 'View', 'Active online form', 'Reservations', '');
          }
        }
      ]
    });
    alert.present();
  }

  markFullDay() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('reservas-marcar-dia-completo'),
      message: this.translate.instant('reservas-quieres-marcar-dia') + moment(this.reservationsServices.selected_date).format('DD/MM/YYYY') + ' ' + this.translate.instant('general-completo').toLowerCase() + '?',
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('Reservations', 'Reservations - MarkFullDay', this.globals.restaurant.email, 'View', 'MarkFullDay', 'Reservations', '');
            let complete_stripes_filter = this.reservationsServices.reservations_stripe_complete.filter(x => x.date === moment(this.reservationsServices.selected_date).format('YYYY-MM-DD'));
            let complete_stripes = [
              {
                'UID_RESTAURANT': this.globals.restaurant_uid,
                'date': moment(this.reservationsServices.selected_date).format('YYYY-MM-DD'),
                'stripe': 1,
              },
              {
                'UID_RESTAURANT': this.globals.restaurant_uid,
                'date': moment(this.reservationsServices.selected_date).format('YYYY-MM-DD'),
                'stripe': 2,
              },
              {
                'UID_RESTAURANT': this.globals.restaurant_uid,
                'date': moment(this.reservationsServices.selected_date).format('YYYY-MM-DD'),
                'stripe': 3,
              }
            ];
            complete_stripes.forEach(stripe => {
              let index = complete_stripes_filter.findIndex(x => x.stripe === stripe.stripe);
              if (index == -1) {
                this.reservationsServices.afs.collection('reservation_complete').add(stripe);
              }
            });
          }
        }
      ]
    });
    alert.present();
  }

  openAnalyticsReservation() {
    this.globals.side_menu_active_analytics = true;
    this.globals.side_menu_active = 'informes';
    this.navCtrl.push(AnalyticsPage, {
      scroll_id: 'analytics_reservation'
    });
  }

  sendTrackingReservation() {
    this.analyticsServices.trackingExpReservations('share_reservation', this.globals.tracking_exp['share']);
  }
}


// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-calendar/reservation-calendar.ts